import React, { useState } from "react"
import { RichText } from "prismic-reactjs"
import Image from "./image"
import { css } from "@emotion/core"
import { colors, mq } from "../styles/styles"
import SwiperCore, { Navigation, Thumbs } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import LocalizedLink from "./localizedLink"
import linkResolver from "../utils/linkResolver"

SwiperCore.use([Navigation, Thumbs])

function Feedback({ feedback }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  return (
    <section className="section is-medium is-theme2" css={feedBackCss}>
      <h3 className="title is-3 has-text-centered has-text-weight-semibold pb-4">
        {RichText.asText(feedback.title)}
      </h3>
      <h6 className="subtitle is-5 has-text-centered has-text-weight-light">
        {RichText.asText(feedback.subtitle)}
      </h6>
      <div className="columns is-centered">
        <div className="column is-9">
          <nav className=" py-5">
            <div className=" has-text-centered">
              <Swiper
                // spaceBetween={50}
                slidesPerView={3}
                onSwiper={setThumbsSwiper}
                className="swiper-feedback-thumbs"
              >
                {feedback.feedback.map((fb, i) => {
                  return (
                    <SwiperSlide key={i}>
                      {fb.feedback_image && (
                        <Image
                          sharp={fb.feedback_imageSharp}
                          image={fb.feedback_image}
                        />
                      )}
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          </nav>
        </div>
      </div>
      <div className="columns is-centered is-multiline">
        <Swiper
          thumbs={{ swiper: thumbsSwiper }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          className="swiper-feedback"
        >
          {feedback.feedback.map((fb, i) => {
            return (
              <SwiperSlide key={i}>
                <div className="column box is-7 has-text-centered has-text-weight-medium px-5 py-5 speech-bubble">
                  <h6 className="title is-4">
                    {RichText.asText(fb.feedback_title)}
                  </h6>
                  <div className="is-size-5 has-text-weight-light">
                    {fb.feedback_content &&
                      RichText.render(fb.feedback_content, linkResolver)}
                  </div>
                  <hr />
                  <div className="has-text-weight-semibold is-size-5">
                    {fb.feedback_name}
                  </div>
                  <div className="has-text-weight-light is-size-7">
                    {fb.feedback_rank}
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
          <div role="button" className="swiper-button-prev btn-shadow"></div>
          <div role="button" className="swiper-button-next btn-shadow"></div>
        </Swiper>
      </div>
    </section>
  )
}

export default Feedback

const feedBackCss = css`
  .box {
    border-radius: 12px;
    box-shadow: 0 19px 7px 0 #c5ccde;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-bottom-color: #fff;
      border-top: 0;
      margin-left: -20px;
      margin-top: -20px;
    }
  }

  hr {
    border-top: 1px dotted ${colors.lightgray};
    background-color: transparent;
    height: 0;
    width: 190px;
    margin: 1.5rem auto;
  }

  img {
    height: 60px;
    width: auto;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-feedback {
    padding-bottom: 40px;
  }

  @media (max-width: 768px) {
     .swiper-button-prev, .swiper-button-next {
       background-color: transparent;
     }
  }

  @media (min-width: 1024px) {
    .swiper-feedback .swiper-slide.swiper-slide-next {
      overflow: visible;
      right: 33%;
      opacity: 30%;
    }

    .swiper-feedback .swiper-slide.swiper-slide-prev {
      overflow: visible;
      left: 33%;
      opacity: 30%;
    }
  }
`
const swiperThumbs = css`
  .swiper-slide {
    cursor: pointer;
    width: auto;
  }
`
